var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"meniu fixed wh100 left0 top0 z99 flex-center"},[_c('ul',_vm._l((_vm.meniu),function(item,key){return _c('li',{key:key,on:{"click":function($event){return _vm.selectItem(key)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }